module.exports = __webpack_public_path__ + "img/infocamere.8981ef35.png";